import { render } from "./SwitchNumbers.vue?vue&type=template&id=666f3763&scoped=true"
import script from "./SwitchNumbers.vue?vue&type=script&lang=js"
export * from "./SwitchNumbers.vue?vue&type=script&lang=js"

import "./SwitchNumbers.vue?vue&type=style&index=0&id=666f3763&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666f3763"]])

export default __exports__